import { schema } from 'normalizr';

const workflowSchema = new schema.Entity('workflows');
export const workflowListSchema = [workflowSchema];
